"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.selectFilterKey = exports.hideFilter = exports.showFilter = exports.removePersona = exports.addPersona = exports.setSelectedSuggestionIndex = exports.addSuggestions = exports.selectSuggestionByIndex = exports.clearSearch = exports.search = void 0;

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/find"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _Suggestion = require("@uifabric/portal-ux/lib/components/Search/Suggestion");

var _connectedReactRouter = require("connected-react-router");

var _SearchActions = require("../../models/SearchActions");

var _searchRegistry = require("../searchRegistry");

var search = function search(state, action) {
  var searchTerm = action.payload;
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    searchTerm: searchTerm
  });
};

exports.search = search;

_searchRegistry.searchRegistry.add(_SearchActions.SearchActions.searchChanged, search);

var clearSearch = function clearSearch(state) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    searchTerm: '',
    personaPills: [],
    suggestionsSet: undefined,
    selectedFilterKey: undefined
  });
};

exports.clearSearch = clearSearch;

_searchRegistry.searchRegistry.add(_SearchActions.SearchActions.clearSearch, clearSearch);

_searchRegistry.searchRegistry.add(_connectedReactRouter.LOCATION_CHANGE, clearSearch);

var selectSuggestionByIndex = function selectSuggestionByIndex(state, action) {
  var index = action.payload;

  if (state.suggestionsSet === undefined || index === undefined) {
    return state;
  }

  var suggestion = state.suggestionsSet.suggestions[index];

  if (suggestion === undefined) {
    return state;
  }

  var personaPills = state.personaPills;

  if (isPersonaSuggestion(suggestion)) {
    personaPills = [suggestion];
  }

  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    selectedSuggestionIndex: index,
    personaPills: personaPills,
    searchTerm: ''
  });
};

exports.selectSuggestionByIndex = selectSuggestionByIndex;

_searchRegistry.searchRegistry.add(_SearchActions.SearchActions.selectSuggestionByIndex, selectSuggestionByIndex);

function isPersonaSuggestion(suggestion) {
  return suggestion.kind === _Suggestion.SuggestionKind.persona;
}

var addSuggestions = function addSuggestions(state, action) {
  if (!action.payload) {
    return state;
  }

  var currentSuggestionsSet = state.suggestionsSet;
  var currentTraceId = state.suggestionsSet && state.suggestionsSet.traceId;

  if (currentSuggestionsSet && currentTraceId !== undefined) {
    if (action.payload.traceId < currentTraceId) {
      return state;
    } else if (action.payload.traceId === currentTraceId) {
      var _context;

      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        suggestionsSet: {
          traceId: action.payload.traceId,
          isComplete: true,
          suggestions: (0, _concat.default)(_context = currentSuggestionsSet.suggestions).call(_context, action.payload.suggestions)
        }
      });
    }
  }

  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    suggestionsSet: {
      traceId: action.payload.traceId,
      isComplete: true,
      suggestions: action.payload.suggestions || []
    }
  });
};

exports.addSuggestions = addSuggestions;

_searchRegistry.searchRegistry.add(_SearchActions.SearchActions.addSuggestions, addSuggestions);

var setSelectedSuggestionIndex = function setSelectedSuggestionIndex(state, action) {
  var index = action.payload;
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    selectedSuggestionIndex: index
  });
};

exports.setSelectedSuggestionIndex = setSelectedSuggestionIndex;

_searchRegistry.searchRegistry.add(_SearchActions.SearchActions.setSelectedSuggestionIndex, setSelectedSuggestionIndex);

var addPersona = function addPersona(state, action) {
  var personaToAdd = action.payload;

  if (personaToAdd === undefined) {
    return state;
  }

  var personaPills = state.personaPills;

  if ((0, _find.default)(personaPills).call(personaPills, function (value) {
    return value.objectId === personaToAdd.objectId;
  }) === undefined) {
    personaPills = (0, _concat.default)(personaPills).call(personaPills, personaToAdd);
  }

  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    personaPills: personaPills,
    searchTerm: '',
    suggestionsSet: undefined
  });
};

exports.addPersona = addPersona;

_searchRegistry.searchRegistry.add(_SearchActions.SearchActions.addPersona, addPersona);

var removePersona = function removePersona(state, action) {
  var _context2;

  var suggestionToRemove = action.payload;

  if (suggestionToRemove === undefined) {
    return state;
  }

  var personaPills = (0, _filter.default)(_context2 = state.personaPills).call(_context2, function (suggestion) {
    return suggestion.objectId !== suggestionToRemove.objectId;
  });
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    personaPills: personaPills
  });
};

exports.removePersona = removePersona;

_searchRegistry.searchRegistry.add(_SearchActions.SearchActions.removePersona, removePersona);

var showFilter = function showFilter(state, action) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    showFiltersMenu: true
  });
};

exports.showFilter = showFilter;

_searchRegistry.searchRegistry.add(_SearchActions.SearchActions.showFilter, showFilter);

var hideFilter = function hideFilter(state, action) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    showFiltersMenu: false
  });
};

exports.hideFilter = hideFilter;

_searchRegistry.searchRegistry.add(_SearchActions.SearchActions.hideFilter, hideFilter);

var selectFilterKey = function selectFilterKey(state, action) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    selectedFilterKey: action.payload
  });
};

exports.selectFilterKey = selectFilterKey;

_searchRegistry.searchRegistry.add(_SearchActions.SearchActions.selectFilterKey, selectFilterKey);